import { createRouter, createWebHashHistory } from 'vue-router'
import AppLayout from '@/layout/AppLayout.vue'
import MobileLayout from '@/layout/AppMobileLayout.vue'
import { ISystemStep } from '@/service/api'
// @ts-ignore
import { useCookies } from 'vue3-cookies'

const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: '/',
      component: AppLayout,
      children: [
        {
          path: '/',
          name: 'constructionItemsRoot',
          component: () => import('@/components/construction/site/page/SiteEditorPage.vue')
        },
        {
          path: '/siteEdit',
          name: 'siteEdit',
          component: () => import('@/components/construction/site/page/SiteEditorPage.vue')
        },
        {
          path: '/constructionItems',
          name: 'constructionItems',
          component: () => import('@/components/construction/constructionItem/page/ConstructionItemListPage.vue')
        },
        {
          path: '/constructionItemsImport',
          name: 'constructionItemsImport',
          component: () => import('@/components/construction/constructionItem/page/ImportConstructionItemsPage.vue')
        },
        {
          path: '/constructionDeliveryList',
          name: 'constructionDeliveryList',
          component: () => import('@/components/construction/delivery/pages/ConstructionDeliveryListPage.vue')
        },
        {
          path: '/newOutgoingDelivery',
          name: 'newOutgoingDelivery',
          component: () => import('@/components/construction/delivery/pages/ConstructionOutgoingDeliveryPage.vue'),
          props: { editDeliveryId: '' }
        },
        {
          path: '/editOutgoingDelivery',
          name: 'editOutgoingDelivery',
          component: () => import('@/components/construction/delivery/pages/ConstructionOutgoingDeliveryPage.vue'),
          props: route => ({ editDeliveryId: route.query.editDeliveryId })
        },
        {
          path: '/newIncomingDelivery',
          name: 'newIncomingDelivery',
          component: () => import('@/components/construction/delivery/pages/ConstructionIncomingDeliveryPage.vue'),
          props: { editDeliveryId: '' }
        },
        {
          path: '/editIncomingDelivery',
          name: 'editIncomingDelivery',
          component: () => import('@/components/construction/delivery/pages/ConstructionIncomingDeliveryPage.vue'),
          props: route => ({ editDeliveryId: route.query.editDeliveryId })
        },
        // Here starts task assignment
        {
          path: '/workItems/surfacePreparation',
          name: 'workItemsSurfacePreparation',
          component: () => import('@/components/construction/workorder/pages/SurfacePreparationAssignmentPage.vue'),
          props: { step: ISystemStep.SURFACE_PREPARATION }
        },
        {
          path: '/workItems/primerPainting',
          name: 'workItemsPrimerPainting',
          component: () => import('@/components/construction/workorder/pages/PrimerPaintingAssignmentPage.vue'),
          props: { step: ISystemStep.PRIMER_PAINTING }
        },
        {
          path: '/workItems/fireProtectionPainting',
          name: 'workItemsFireProtectionPainting',
          component: () => import('@/components/construction/workorder/pages/FireProtectionAssignmentPage.vue'),
          props: { step: ISystemStep.FIRE_PROTECTION_PAINTING }
        },
        {
          path: '/workItems/interLayerPainting',
          name: 'workItemsInterLayerPainting',
          component: () => import('@/components/construction/workorder/pages/InterLayerAssignmentPage.vue'),
          props: { step: ISystemStep.INTER_LAYER_PAINTING }
        },
        {
          path: '/workItems/topLayerPainting',
          name: 'workItemsTopLayerPainting',
          component: () => import('@/components/construction/workorder/pages/TopLayerAssignmentPage.vue'),
          props: { step: ISystemStep.TOP_COAT_PAINTING }
        },
        {
          path: '/workItems/thicknessMeasurement',
          name: 'workItemsThicknessMeasurement',
          component: () => import('@/components/construction/workorder/pages/ThicknessMeasurementAssignmentPage.vue'),
          props: { step: ISystemStep.THICKNESS_MEASUREMENT }
        },
        {
          path: '/workItems/workLoad',
          name: 'workItemsWorkLoad',
          component: () => import('@/components/construction/workorder/pages/WorkLoadPage.vue')
        },
        {
          path: '/workItems/groups',
          name: 'workItemsGroups',
          component: () => import('@/components/construction/warehouse/pages/WarehouseItemGroupsListPage.vue')
        },
        {
          path: '/reports/thickness',
          name: 'thicknessReport',
          component: () => import('@/components/construction/reports/thickness/pages/ThicknessReportPage.vue')
        },
        {
          path: '/reports/usage',
          name: 'usageReport',
          component: () => import('@/components/construction/reports/usage/pages/UsageReportPage.vue')
        },
        {
          path: '/reports/paintConsumption',
          name: 'paintConsumptionReport',
          component: () => import('@/components/construction/reports/paintconsumption/PaintConsumptionReportPage.vue')
        },
        {
          path: '/userList',
          name: 'userList',
          component: () => import('@/components/authorization/pages/UserListPage.vue')
        },
        {
          path: '/printers',
          name: 'printers',
          component: () => import('@/components/printers/pages/PrintersListPage.vue')
        },
        {
          path: '/contractors',
          name: 'contractors',
          component: () => import('@/components/contractor/pages/ContractorsListPage.vue')
        },
        {
          path: '/contractor/list',
          name: 'contractorList',
          component: () => import('@/components/contractor/pages/ContractorsListPage.vue')
        },
        {
          path: '/contractor/new',
          name: 'contractorNew',
          component: () => import('@/components/contractor/pages/ContractorDetailPage.vue'),
          props: { createNew: true }
        },
        {
          path: '/contractor/:shortName',
          name: 'contractorEdit',
          component: () => import('@/components/contractor/pages/ContractorDetailPage.vue'),
          props: route => ({
            createNew: false,
            shortName: route.params.shortName
          })
        },
        {
          path: '/user/profile',
          name: '/user/profile',
          component: () => import('@/components/authorization/pages/ProfilePage.vue')
        },
        {
          path: 'thicknessMeasurementList',
          name: 'thicknessMeasurementList',
          component: () => import('@/components/construction/measurement/pages/ThicknessMeasurementListPage.vue')
        },
        {
          path: 'reports/siteItemsReport',
          name: 'siteItemsReport2',
          component: () => import('@/components/construction/reports/siteItems/pages/SiteItemReportPage.vue')
        }
      ]
    },
    {
      path: '/mobile',
      component: MobileLayout,
      children: [
        {
          path: '/mobile/workLoad',
          name: 'workItemsWorkLoadMobile',
          component: () => import('@/components/construction/workorder/pages/WorkLoadMobilePage.vue')
        },
        {
          path: '/mobile/user/profile',
          name: 'mobile/user/profile',
          component: () => import('@/components/authorization/pages/MobileProfilePage.vue')
        }
      ]
    },
    {
      path: '/auth/login',
      name: 'login',
      component: () => import('@/components/authorization/pages/LoginPage.vue')
    },
    {
      path: '/paint',
      component: AppLayout,
      children: [
        {
          path: 'paintList',
          name: 'paintList',
          component: () => import('@/components/paint/pages/PaintListPage.vue')
        },
        {
          path: 'paintOrderList',
          name: 'paintOrderList',
          component: () => import('@/components/paint/pages/PaintOrderListPage.vue')
        },
        {
          path: 'createPaintOrder',
          name: 'createPaintOrder',
          component: () => import('@/components/paint/pages/PaintOrderDetailsPage.vue')
        },
        {
          path: 'createPaintDeliveryV2',
          name: 'createPaintDeliveryV2',
          component: () => import('@/components/paint/pages/PaintDeliveryCreatePage.vue')
        },
        {
          path: 'paintWarehouseItems',
          name: 'paintWarehouseItems',
          component: () => import('@/components/paint/pages/PaintWarehouseItemsPage.vue')
        },
        {
          path: 'paintIssuance',
          name: 'paintIssuance',
          component: () => import('@/components/paint/pages/PaintIssuancePage.vue')
        },
        {
          path: 'mockPaintIssuance',
          name: 'mockPaintIssuance',
          component: () => import('@/components/paint/pages/PaintIssuanceMockPage.vue')
        },
        {
          path: 'paintConsumption',
          name: 'paintConsumption',
          component: () => import('@/components/paint/pages/PaintConsumptionPage.vue')
        },
        {
          path: 'mockPaintConsumption',
          name: 'mockPaintConsumption',
          component: () => import('@/components/paint/pages/PaintConsumptionMockPage.vue')
        },
        {
          path: 'editPaintOrder/:id',
          name: 'editPaintOrder',
          component: () => import('@/components/paint/pages/PaintOrderDetailsPage.vue')
        },
        {
          path: 'editPaint',
          name: 'editPaint',
          component: () => import('@/components/paint/pages/PaintDetailsPage.vue'),
          props: route => ({ paintId: route.query.paintId, createNewPaint: false })
        },
        {
          path: 'createPaint',
          name: 'createPaint',
          component: () => import('@/components/paint/pages/PaintDetailsPage.vue'),
          props: { createNewPaint: true }
        },
        {
          path: 'paintDeliveryList',
          name: 'paintDeliveryList',
          component: () => import('@/components/paint/pages/PaintDeliveryListPage.vue')
        },
        {
          path: 'createPaintDelivery',
          name: 'createPaintDelivery',
          component: () => import('@/components/paint/pages/PaintDeliveryDetailsPage.vue'),
          props: { createNew: true }
        },
        {
          path: 'editPaintDelivery/:id',
          name: 'editPaintDelivery',
          component: () => import('@/components/paint/pages/PaintDeliveryDetailsPage.vue'),
          props: route => ({
            createNew: false,
            deliveryId: route.params.id
          })
        },
        {
          path: 'displayPaintWarehouse',
          name: 'displayPaintWarehouse',
          component: () => import('@/components/paint/pages/PaintWarehouseReportPage.vue'),
          props: route => ({
            createNew: false,
            deliveryId: route.params.id
          })
        }

      ]
    }

  ]
})

// Navigation guard - check authentication before accessing protected routes
router.beforeEach((to, _from, next) => {
  const publicRoutes = ['/auth/login']
  const isPublicRoute = publicRoutes.includes(to.path)

  // Check if user has a valid token
  const token = useCookies().cookies.get('token')

  if (!isPublicRoute && !token) {
    // No token and trying to access protected route - redirect to login
    next('/auth/login')
  } else if (to.path === '/auth/login' && token) {
    // Already logged in and trying to access login page - redirect to home
    next('/')
  } else {
    next()
  }
})

export default router
